<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For Mary Alice Gorman,<br/>who was there at Josie’s birth.<br/>Enjoy her wedding.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?1487e894